import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "content-home"
};
import PartTop from './partTop.vue';
import PartBottom from './partBottom.vue';
import { useAiff } from '@/hooks/useAiff';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    useAiff();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(PartTop), _createVNode(PartBottom)]);
    };
  }
});